import React, { Component } from 'react';
import {FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import CustomLoader from './CustomLoader';

export class AdminComments extends Component {
  displayName = AdminComments.name

  constructor(props) {
    super(props);

    this.state = {
      comments: [],
      commentsPublish: [],
      showDeleteModal: false,
      deleteCommentId: null,
      loader: true
    }

    this.publishComment = this.publishComment.bind(this);
    this.removeComment = this.removeComment.bind(this);
    this.closeDeleteCommentModal = this.closeDeleteCommentModal.bind(this);
  }

  componentDidMount() {
    Promise.all([
      fetch('api/DataforDB/GetNotPublishComments')
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then(data => {
          this.setState({ comments: data });
        }),
      fetch('api/DataforDB/GetPublishComments')
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then(data => {
          this.setState({ commentsPublish: data });
        })
    ]).then(() => this.setState({ loader: false }));
  }

  publishComment(id) {
    var data = new FormData();
    data.append('commentId', id);

    const requestOptions = {
        method: 'POST',
        body: data
    };

    fetch('api/DataforDB/PublishComment', requestOptions)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(() => {
          this.setState({comments: this.state.comments.filter(x => x.id !== id)})
      })
      .catch(error => toast.error('Произошла ошибка при публикации комментария'));
  }

  removeComment() {
    var data = new FormData();

    const id = this.state.deleteCommentId;

    data.append('commentId', id);

    const requestOptions = {
        method: 'POST',
        body: data
    };

    fetch('api/DataforDB/RemoveComment', requestOptions)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(() => {
          this.setState({comments: this.state.comments.filter(x => x.id !== id)}, this.closeDeleteCommentModal)
      })
      .catch(error => toast.error('Произошла ошибка при удалении комментария'));
  }

  closeDeleteCommentModal() {
    this.setState({ showDeleteModal: false, deleteCommentId: null })
  }

  render() {
    return (
      <React.Fragment>
        <CustomLoader visible={this.state.loader}/>
        <div className={this.state.loader ? 'display-none' : ''}>
          <ToastContainer/>
          <Modal isOpen={this.state.showDeleteModal}>
            <ModalHeader>Подтверждение операции</ModalHeader>
            <ModalBody>
              Вы уверены что хотите удалить этот комментарий?
            </ModalBody>
            <ModalFooter>
              <button className='btn btn-primary' onClick={this.removeComment}>Подтвердить</button>
              <button className='btn' onClick={this.closeDeleteCommentModal}>Отменить</button>
            </ModalFooter>
          </Modal>
          <h1>Администрирование отзывов</h1>
          <FormGroup>
            <h2>Новые</h2>
            {this.state.comments.length === 0 && <FormGroup className='alert alert-primary'>Новых отзывов не найдено</FormGroup>}
            {this.state.comments.map(c => {
              return (
              <div key={c.id} className='comment-block'>
                <h6 className='comment-title'>{c.nameAuthor}</h6>
                <FormGroup>
                  {c.commentText}
                </FormGroup>
                <FormGroup>
                    <button className='btn btn-primary' onClick={() => this.publishComment(c.id)}>Опубликовать</button>
                    <button className='btn btn-danger' onClick={() => this.setState({ deleteCommentId: c.id, showDeleteModal: true })}>Удалить</button>
                </FormGroup>
              </div>);
            })}
          </FormGroup>
          <FormGroup>
            <h2>Опубликованные</h2>
            {this.state.commentsPublish.length === 0 && <FormGroup className='alert alert-primary'>Опубликованных отзывов не найдено</FormGroup>}
            {this.state.commentsPublish.map(c => {
              return (
              <div key={c.id} className='comment-block'>
                <h6 className='comment-title'>{c.nameAuthor}</h6>
                <FormGroup>
                  {c.commentText}
                </FormGroup>
                <FormGroup>
                    <button className='btn btn-danger' onClick={() => this.setState({ deleteCommentId: c.id, showDeleteModal: true })}>Удалить</button>
                </FormGroup>
              </div>);
            })}
          </FormGroup>
        </div>
      </React.Fragment>
    );
  }
}
